import React from "react";
import "./App.css"; // Import the CSS file for styling


function DebtRecoveryCases(){

    return <div>

<img src="/supreme-court-of-india.jpg" alt="Header" />
<h2>Debt Recovery Cases</h2>



    </div>;


}




export default DebtRecoveryCases;